import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[collapse]',
  standalone: true,
  template: '<ng-content />',
  animations: [
    trigger('collapse', [
      state('0', style({ height: '0', overflow: 'hidden' })),
      state('1', style({ height: '*', overflow: 'hidden' })),
      transition('0 <=> 1', animate('{{duration}}ms {{easing}}'), {
        params: {
          duration: 300,
          easing: 'ease-in-out',
        },
      }),
    ]),
  ],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class CollapseDirective {
  @HostBinding('@collapse')
  @Input()
  collapse: boolean;
}
